// İSG uzmanı portalı — Güvenlik masası karar kartı (S32 tasarım spec'i §5; S32b
// `docs/reviews/S32b-gate-desk-relayout.md` Option A §2, "the verdict is a property of the
// desk"). Sayfanın TEK verdict yüzeyi — kapı kodu okutması VE TC sorgusu bu kartı PAYLAŞIR,
// `VerdictPanel.tsx` içinde, sekmelerin DIŞINDA render edilir.
//
// Dört varyant: `allowed` (yeşil), `denied` (kırmızı, beş izin sebebi — jeton hâli BURADA
// YOKTUR, o `GateStage`'in ayrı bir paneli, §5.2), `notFound` (TC `found=false`, NÖTR — bir ret
// DEĞİL), `networkError` (ağ hatası, NÖTR — bir ret DEĞİL, tasarım spec'i §8.8 "absolute rule").
// Renk hiçbir zaman TEK BAŞINA taşıyıcı değildir — her varyant kendi ikonu + kendi sözcüğüyle
// gelir.
//
// **S32d yeniden çizimi (`docs/reviews/S32d-verdict-and-detail.md` Option A, §1-4) — sahip
// canlı veriyle gördüğü şipiş kartı "gerçekten çirkin" bulduktan SONRA yazıldı; §1 teşhisi
// BAĞLAYICIdır: karar SÖZCÜĞÜ 18px, yanındaki AD 30px'ti — kararın kendisi karttaki EN KÜÇÜK
// tipografiydi ve onu bir karar gibi okutan TEK şey 64px'lik doygun-renk bir bantTI. Çözüm
// doygun ALAN yerine tipografi BOYUTU + TEK bir tentle ödemek:**
//   - Eski `rounded-lg` "bant" (min-h-16, tam-genişlik doygun dolgu) KALKTI. Karar sözcüğü artık
//     `text-3xl` (30px) — kart üzerindeki EN BÜYÜK tipografi — ve kimlikle AYNI `*-subtle` tent
//     şeridinde, TEK doygun eleman 4px'lik sol kural çubuğu.
//   - Eski iki-sütunlu gövde (`md:w-[26rem]` sabit kimlik sütunu + `h-5` REZERVE boş satır)
//     KALKTI — kimlik artık kararla AYNI şeritte YATAY bir döşeme (avatar + ad + tek meta
//     satırı). `contractorName=null` artık hiçbir yükseklik REZERVE ETMEZ (yatay meta satırında
//     eksik bir öğe hiçbir şey MALİYETLENDİRMEZ, S32c §13.5'in dikey-sütun gerekçesi burada
//     GEÇERSİZLEŞİR — bkz. doküman §1.5).
//   - Eski `max-h-40 overflow-y-auto` kaydırmalı izin kuyusu KALKTI (F2 defekti — bir satırı
//     harfin ORTASINDAN kesmek "daha ÇOK var" der ama "NE KADAR" demez). İzin listesi artık
//     SABİT yükseklikte bir şerit: en çok İKİ satır, üçüncü+ `+N izin daha` (SAYIYLA kırpma,
//     PIKSELLE değil — tablo'nun `truncate`+`title` kuralıyla AYNI disiplin). Tarih aralığı
//     `formatDateRange` (`lib/format.ts`, `Intl.formatRange`) — iki `formatDateTime` çağrısının
//     37 karakterlik "20:20 – 20:20" gürültüsü yerine 15 karakterlik `17–31 Ağu 2026`.
//   - Eski tam-genişlik `bg-warning` uyuşmazlık BARI (~670px) bir CHIP'e küçüldü (`Badge
//     tone="warning"`, eyebrow satırında, ~200px) — aynı anahtar, aynı token, ~%70 daha az alan.
//   - Eski dolgu-birincil `Kapat` (320px slab) düğmesi artık AĞIRLIĞI DURUMA göre değişir:
//     kuyruk boşken `secondary` (kartı ATAN bir kontrol yüksek sesli OLMAMALI), kuyruk doluyken
//     `primary` (kapıda bekleyen VARSA bu GERÇEKTEN masanın birincil eylemi). Sabit hücre YERİNE
//     düğmenin kendi satırı (`h-14` eylem çubuğu) sabit pikseli TAŞIR — `max-w-[20rem]` ARTIK
//     GEREKMEZ.
//   - Ayrı `VerdictAgeLine` şeridi KALKTI — yaş artık AYNI zaman yuvasında bir sonek
//     (`VerdictAgeSuffix`, F5 defekti: kart beşinci bir yatay bölge KAZANMASIN, "ne zaman"ın TEK
//     bir okuma yeri olsun).
//   - S32c §4.5'in "taşınmış" ret-önizleme ikonu (`Sıradaki (N)` içinde `OctagonX`) ARTIK
//     GÖNDERİLİYOR — `useVerdictStage.ts`'in `nextIsDenial`'ı buraya `nextIsDenial` propuyla
//     akar.
//
// **Sabit geometri artık YAPISAL, aritmetik DEĞİL** (F3'ün S32d cevabı) — kart ÜÇ satırdır:
// kimlik+karar şeridi (`min-h-[11rem]`, TÜM varyantlarda AYNI sınıf — `notFound`/`networkError`
// kimliksiz kalınca `justify-center` sözcüğü ORTALAR, satır KÜÇÜLMEZ), kanıt şeridi (S32f'den
// beri `flex-1 min-h-[9rem]` — ARTIK sabit DEĞİL, kartın kalan yüksekliğini DOLDURUR ve İÇİNDE
// kaydırır, aşağıdaki S32f notuna bkz.), eylem çubuğu (`h-14`). `web-qa-engineer` gerçek
// pikselleri DOĞRULAMALI (`VerdictPanel.tsx`'in `min-h-[…]`'i bu üç satırın toplamından
// TÜRETİLDİ, aritmetikten — S32c E5'in AYNI uyarısı burada da geçerli).
//
// **S32e düzeltme turu (`docs/reviews/S32e-evidence-and-layout.md`) — owner canlı veriyle
// bulduğu ÖZ-ÇELİŞKİLİ yeşil kartın ÜÇ sebebi burada kapanır:**
//   - **G1 (kontrat ihlali, DÜZELTİLDİ).** `hasLiveMismatch` eskiden BİRİ `entryPermitted=false`
//     iken ateşliyordu; §29.5 madde 3 **hiçbiri** `entryPermitted=true` DEĞİLKEN (boş liste DÂHİL)
//     ister. Ayrım DİZİNİN VARLIĞINDA — kapı yolunda `permits` DAİMA bir dizidir (boş olabilir,
//     `null` OLMAZ), TC yolunda `undefined`'dır ve orada bu kural HİÇ DEĞERLENDİRİLMEZ (izin
//     listesi hiç dönmez, yalnız `permitTitle`). `EntryDetailModal.tsx:75-76` bunu zaten DOĞRU
//     yapıyordu — iki yüzey artık AYNI kararı veriyor. **S32f'de de DEĞİŞMEDİ** — anahtar HÂLÂ
//     `entryPermitted` üzerinde tanımlı, `validityState` ile DARALTILMAZ (aşağıdaki S32f notu).
//   - **Tarih aralığı SATIRDAN KALKTI.** Sunucu zaten aralığa göre KARAR VERMİŞ (pencere dışı bir
//     izin `OutOfValidity` üretir) — Almanca'da satırın yarısından FAZLASINI yiyen bir bilgi
//     hiçbir kararı DEĞİŞTİREMEZ. Aralık `EntryDetailModal.tsx:213`'te KALDI (inceleme yüzeyi
//     odur). İzinli satır artık `CircleCheck` + `text-success` taşır (izinsiz zaten `OctagonX`
//     taşıyordu) — iki durumun İKİSİ de aynı ikon+sözcük ağırlığında.
//
// **S32f turu (`docs/reviews/S32e-evidence-and-layout.md` PART FOUR, §13-§21) — owner canlı
// veriyle bulduğu İKİ şey TEK değişiklik olarak kapanır (H1/H2/H3/H4/H6/H7):**
//   - **H1/H2 (kontrat genişlemesi + sıralama).** `entryPermitted` bir HİBEDİR, `validityState`
//     (YENİ altıncı alan, `lib/permitWindow.ts`) AYRI bir PENCEREDİR — 1 Aralık'ta başlayan bir
//     izin bugün `entryPermitted=true` taşıyabilir ve bu DOĞRUDUR, kapıda yine REDDEDİLİR
//     (`OutOfValidity`). Eski sıralama anahtarı (yalnız hibe) bu izni izin listesinin EN BAŞINA
//     koyuyordu — mümkün olan EN KÖTÜ yer. Sıralama artık `lib/permitWindow.ts`'in `rankPermits`'i
//     (§17): rank 0 aktif+hibe (yeşil), 1 aktif hibesiz (kırmızı), 2 ileri tarihli (NÖTR,
//     `Calendar`), 3 süresi geçmiş (NÖTR, `CalendarOff`). NÖTR — KIRMIZI DEĞİL: kırmızı zaten
//     "giriş izni yok"un anlamı, ikinci bir anlam kazanırsa guard'ı yanlış telefon görüşmesine
//     yollar (S32e §16).
//   - **H4 (overflow satırı EMEKLİ).** `+N izin daha · B izinde giriş izni yok` `!entryPermitted`
//     sayıyordu — pencere ekseniyle hibe eksenini TEK cümlede KARIŞTIRIYORDU. Yerini pencere
//     dışı kırılımı (`{{future}} ileri tarihli · {{expired}} süresi geçmiş`, TÜM liste üzerinden)
//     + kaydırma varsa görünen bir `⌄ aşağıda devam ediyor` işaretine bıraktı.
//   - **H3/H6/H7 (şerit TAM yükseklik, kaydırılır).** İKİ satırlık tavan (`MAX_VISIBLE_PERMITS`)
//     KALKTI — liste artık kartın kalan yüksekliğini DOLDURUR (`flex-1 min-h-0 overflow-y-auto`,
//     `tabIndex={0}` YALNIZ taştığında — Chrome'da klavyeyle kaydırılabilir olması için, H7) ve
//     yalnız GERÇEK taşmada kaydırır. Sıralama BUNU GÜVENLİ kılan şeydir: kıvrım (fold) yalnız
//     bugüne KARAR VEREMEYEN satırların (rank 2/3) ya da zaten görünen bir sınıfın akranlarının
//     ALTINA düşebilir. `denied`'in kırmızı ret bloğu artık `h-full` DEĞİL (H3 — eskiden ~585×350
//     bir tinte GEREKSİZ yere geriliyordu), kendi `shrink-0` kutusu; altına AYNI sıralı liste
//     eklendi (§15.1, owner onayı BEKLİYOR — bkz. `denied` dalının başındaki not).
//   - **Kart `h-full flex-col`, kanıt şeridi `flex-1 min-h-[9rem]`.** Taban S32e'nin İKİ satırlık
//     `7.5rem`'inden ÜÇ satırlık `9rem`'e çıktı (§18 "floor" kuralı) — `web-qa-engineer` gerçek
//     pikseli DOĞRULAMALI. S32e Part Two'nun `[Karar | Giriş]` ızgarasında (`SecuritySiteSession.tsx`)
//     satırın yüksekliğini `Giriş` belirliyor; kimlik+karar şeridi ve eylem çubuğu SABİT kalır.
//   - **Ne KAPSAM DIŞI bırakıldı, bilerek:** `hasLiveMismatch`'i pencereye göre DARALTMAK
//     TEKLİF EDİLMEDİ — notun metni "İzin bu okutmadan sonra DEĞİŞTİ" der, kendiliğinden
//     SONA EREN bir izin DEĞİŞMEMİŞTİR; pencereye bağlarsak her akşam gözden geçirilen bir güne
//     bu YANLIŞ cümleyi basardık (§21.1 madde 1, owner talimatı olarak da geldi).
//   - **`GateStage.tsx`'in üçüncü site-adı kopyası SİLİNDİ** (S32e §4.3 madde 3, hiç
//     GÖNDERİLMEMİŞTİ) — sayfa `h1`'i VE bağlam çubuğu `Select`'i zaten aynı sözcüğü taşıyor.
//     **Bu kalan boşluğu KAPATMAZ** — birincil sebep `GateStage`'in `min-h-[28rem]` QR tabanı
//     (§18.1); tek-izinli bir kartta ~300px hava KALIR, bu görev o tabanı DEĞİŞTİRMEZ.
//
// **S32b'de DEĞİŞEN (kendi paneli, D1/D2 defektleri) — hâlâ GEÇERLİ:**
//   - `personnelName` `line-clamp-2 break-words` (D1).
//   - `scannedAt` hem `allowed` HEM `denied`'de gösterilir (D2).
//   - `queuedCount` rozeti panel BAŞLIĞINDA DEĞİL, düğmede (`VerdictPanel.tsx`).
//
// **İkinci tur, owner canlı-kullanım bulgusu (auto-clear KALDIRILDI) — hâlâ GEÇERLİ:**
//   - Hiçbir varyant kendini zamanla TEMİZLEMEZ. `onAcknowledge` düğmesi DÖRT varyantın
//     DÖRDÜNDE de render edilir — kuyruğu ilerletebilen TEK guard eylemi bu olduğundan.
//   - Yaş soneki `scannedAt` taşıyan HER varyantta çıkar (`allowed` DÂHİL) — bir karar süresiz
//     ekranda kalabildiğinden "hâlâ güncel mi" sorusu yalnız `denied`'e özgü değil.
//
// **S32g (`docs/reviews/S32g-eligibility-checklist.md`, api-contract §29.5 S32g bloğu) — kapı
// uygunluk kontrol listesi.** `lib/eligibility.ts`'in `findEvaluatedPermit`/`eligibilityRows`/
// `eligibilityRouting`'i + `EligibilityChecklist.tsx` (`EntryDetailModal.tsx` ile PAYLAŞILIR).
// 1/2. satırdan biri `Eksik` iken ret bloğunun EYLEM satırı `security.eligibility.route.<hedef>`'e
// DEĞİŞİR (§2.1, ASLA yığılmaz). `allowed`'de: temiz bir onayda (üç satır da geçer) HİÇ render
// EDİLMEZ (§4.2); yalnız BAŞARISIZ bir satır varken (dondurulmuş bir hibe + sonradan bozulmuş bir
// readiness, §4.3) render edilir, yönlendirme cümlesi OLMADAN. Backend bu dilimi henüz
// DAĞITMADIYSA (`entryGrantState`/`closestToEntry`/`readiness` üçü de `undefined`)
// `findEvaluatedPermit` `null` döner ve kontrol listesi TAMAMEN atlanır — bu satırın ÜÇÜ de
// kırmızı render EDİLMEZ.
//
// **S32g PART TWO revizyonu (aynı doküman §15-§26) — owner canlı ekranı "okunması zor ve
// yeterince yapısal değil" bulduktan SONRA, K1/K3/K5 burada kapanır, K2 RETRACTED:**
//   - **K1/K3 (canlı defekt + a11y defekti) `EligibilityChecklist.tsx`'te kapandı** — eksik
//     kalem ADLARI artık `renderPermitList`'in İZİN `<ul>`'ına HİÇ enjekte EDİLMEZ (eskiden
//     `İZİNLER (N)` eyebrow'unun AŞAĞISINDA, o `<ul>`'un İÇİNDE render ediliyordu — bir eksik
//     eğitim dördüncü bir izin gibi okunuyordu VE `aria-labelledby` yanlış sayıyordu). Kalemler
//     artık `EligibilityChecklist`'in KENDİ satırının hücresi İÇİNDE — bkz. o dosyanın başlığı.
//   - **Option A → Option B fallback (aynı dokümanın §2, `S32g-eligibility-checklist.md` §21
//     Option B) — sıralı izin listesi `denied`'DE KALIR.** Option A'yı denedik: kontrol listesi
//     `denied` şeridinin TEK sahibi oldu, listesiz. Owner headline ret ekranında (satır 1/2
//     geçti, satır 3 `Bekleniyor`, kalemsiz) 140-180px'lik boş dikey alan bulduktan sonra Option
//     A'nın §7.4'te YAZILI itiraf ettiği tam açığa DÜŞTÜ — ve owner bu şikâyeti İKİNCİ kez
//     tekrarladı. Fallback UYGULANDI: `İZİNLER (N)` eyebrow'u/kaydırma bölgesi/pinned satır
//     `denied`'e GERİ DÖNDÜ — bkz. `denied` dalının kendi notu. K1 GERİ AÇILMADI: liste yeniden
//     eklenirken `renderPermitList` HÂLÂ yalnız `rankedPermits`'i okur, eligibility kalemi hiç
//     ALMAZ — kart artık kontrol listesi (bordered grup) + `İZİNLER` (bare ruled liste) olmak
//     üzere İKİ ayrı konteynır taşır, kalem bir daha ASLA ikincisine sızmaz. Kart, Option B'nin
//     §21'de yazdığı gibi bu app'in en yoğun yüzeyi kalır; kalem tavanı (`CARD_ITEM_CAP=2`,
//     `EligibilityChecklist.tsx`) bu yüzden ARTIK bir güvenlik payı değil, YÜK TAŞIYAN bir
//     sınırdır. `allowed` DEĞİŞMEDİ, listeyi zaten KORUYORDU.
//   - **K5 (§20) — pinned satırın "ileri tarihli/süresi geçmiş" kırılımı artık YALNIZ liste
//     GERÇEKTEN taşarken (`permitListScrollable`) render edilir** — eskiden liste taşmasa bile
//     her satırın KENDİ çipiyle AYNI sayıyı tekrarlıyordu. SAYIM kuralı DEĞİŞMEDİ (S32e §19
//     madde 1, hâlâ TÜM liste üzerinden).
//   - **K2 RETRACTED** — satır 2/3 arasındaki ÖZEL hairline (2+1 gruplaması) kalktı; bkz.
//     `EligibilityChecklist.tsx`.
//   - **K7 (aynı dokümanın §2) — kontrol listesi grubunun DIŞ sınırı `border-border-strong`'a
//     geçti.** Canlı render'da `border-border` graphite'te 1.30:1 ölçüldü (neredeyse GÖRÜNMEZ);
//     bkz. `EligibilityChecklist.tsx`.

import type {
  GateScanPermitDto,
  SecurityEntryMethod,
  SecurityPermitDenyReason,
  SecurityTokenDenyReason,
} from '@isgportal/shared';
import { Button, Tag, cn, currentCulture, useDocumentTypes } from '@isgportal/shared';
import {
  ChevronDown,
  CircleCheck,
  HardHat,
  MapPin,
  OctagonX,
  SearchX,
  TriangleAlert,
  WifiOff,
} from 'lucide-react';
import { useEffect, useId, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  type EligibilityRow,
  eligibilityRouting,
  eligibilityRows,
  findEvaluatedPermit,
} from '../../lib/eligibility';
import { formatTime } from '../../lib/format';
import {
  PERMIT_CHIP_TEXT_CLASS,
  permitChip,
  permitWindowCounts,
  rankPermits,
} from '../../lib/permitWindow';
import { VerdictAvatar } from './Avatar';
import { EligibilityChecklist } from './EligibilityChecklist';
import { MethodMarker } from './MethodMarker';

export type VerdictCardVariant = 'allowed' | 'denied' | 'notFound' | 'networkError';

export interface VerdictCardProps {
  variant: VerdictCardVariant;
  personnelName?: string | null;
  /** S32c §5, düzeltme §13.5 — personelin (çağıranın firmasındaki) taşeron bağı. `null` →
   *  meta satırında GLİF basılmaz (ne ikon ne metin) — `null` "sunucu çözemedi" demektir, bir
   *  em-dash ise "uygulanamaz" der; ikisini karıştırmak yanlış bir iddia olurdu (`security.ts`
   *  dosya başı notu). S32d ile satır artık YATAY bir meta öğesi — eksikliği hiçbir yükseklik
   *  REZERVE ETMEZ (S32c'nin dikey-sütun `h-5` hilesi buradan KALKTI, §1.5). */
  contractorName?: string | null;
  /** Okutulan/sorgulanan sahanın adı (varsa) — bağlam satırı. */
  siteName?: string | null;
  /** Yalnız `OutOfSite` reddinde kendi içinde tekrar edilir (tasarım spec'i §5.1 [P]). */
  selectedSiteName?: string;
  /** İzin ailesi (`SecurityPermitDenyReason`) ya da — Akış A (`verify`, brief 092) — jeton ailesi
   *  (`SecurityTokenDenyReason`: `TokenExpired`/`TokenConsumed`/`TokenInvalid`). İki aile de
   *  `security.reason.<kod>.label` + `.action` i18n anahtarlarını taşır; tanınmayan kod nötr
   *  `unknown`'a düşer (§29.1 kırıcı-değişiklik kuralı). Kapı/TC yollarında jeton ailesi GELMEZ. */
  reason?: SecurityPermitDenyReason | SecurityTokenDenyReason | null;
  /** Karar anı (ISO) — kapı kodu yolunda sunucu `scannedAt`'i, TC yolunda istemci anı
   *  (`useVerdictStage.ts`). D2 fix: `allowed` VE `denied`'de gösterilir. */
  scannedAt?: string | null;
  /** Kimlik döşemesinin yöntem satırı (S32c §2.2) — kapı yolunda `GateScanDto.method`
   *  (DAİMA `'GateQr'`), TC yolunda sabit `'TcLookup'`. */
  method?: SecurityEntryMethod;
  /** Kapı kodu yolu — okutulan sahaya kapsanmış CANLI izin listesi (§5.3). */
  permits?: GateScanPermitDto[];
  /** TC yolu — yalnız tek başlık döner (§29.5), tam liste YOK. */
  permitTitle?: string | null;
  /** "Onayla"/"Sıradaki" düğmesi yalnız verildiğinde render edilir — auto-clear KALKTIĞINDAN
   *  (dosya başı notu) bu ARTIK dört varyantın DÖRDÜNDE de sağlanır. */
  onAcknowledge?: () => void;
  /** S32c §4 — kuyrukta bekleyen sayısı. `0` iken düğme `Kapat`, `>0` iken `Sıradaki (N)`. */
  queuedCount?: number;
  /** S32d §3.4/S32c §4.5 — kuyruğun BAŞINDAKİ öğe bir ret mi (`useVerdictStage.ts`'in
   *  `nextIsDenial`'ı). `Sıradaki (N)` içinde bir `OctagonX` + `sr-only` uyarı ekler; N kez art
   *  arda tıklanan bir kuyrukta bir reddin OKUNMADAN geçmesini önlemenin TEK yolu bu. */
  nextIsDenial?: boolean;
  className?: string;
}

const REASON_ICON: Record<VerdictCardVariant, typeof CircleCheck> = {
  allowed: CircleCheck,
  denied: OctagonX,
  notFound: SearchX,
  networkError: WifiOff,
};

/** Şerit tenti — TEK doygun eleman sol kural çubuğu (S32d §3.1). */
const STRIP_TONE: Record<VerdictCardVariant, string> = {
  allowed: 'border-success bg-success-subtle',
  denied: 'border-danger bg-danger-subtle',
  notFound: 'border-border-strong bg-surface-muted',
  networkError: 'border-border-strong bg-surface-muted',
};

/** Karar sözcüğü + ikonu — kartın EN BÜYÜK tipografisi, renk İKON+SÖZCÜKLE birlikte taşınır. */
const WORD_TONE: Record<VerdictCardVariant, string> = {
  allowed: 'text-success',
  denied: 'text-danger',
  notFound: 'text-fg',
  networkError: 'text-fg',
};

const REASON_KEYS: SecurityPermitDenyReason[] = [
  'NoPermit',
  'OutOfSite',
  'EntryNotPermitted',
  'OutOfValidity',
  'Terminal',
];

/** Jeton ailesi reddi — YALNIZ Akış A (`verify`, brief 092) üretir (geçersiz/süresi geçmiş/
 *  tüketilmiş personel QR'ı). İzin ailesi (`REASON_KEYS`) gibi `security.reason.<kod>.label` +
 *  `.action` taşır; kapı kodu/TC yollarında HİÇ görünmez (jeton hâli orada ayrı ele alınır). */
const TOKEN_REASON_KEYS: SecurityTokenDenyReason[] = [
  'TokenExpired',
  'TokenConsumed',
  'TokenInvalid',
];

/** İki reddi de bilinen kabul eden birleşik küme — `Set<string>.has` tip daraltma sorunu
 *  olmadan genişletilmiş `reason` birleşimini kabul eder. */
const KNOWN_REASON_SET: ReadonlySet<string> = new Set<string>([
  ...REASON_KEYS,
  ...TOKEN_REASON_KEYS,
]);

/** ~90 sn eşiği (§2.4 kural 7, `allowed`'ı da kapsayacak şekilde GENİŞLETİLDİ) — bu süreden
 *  eski, onaylanmamış bir karar bir yaş soneki çıkarır. */
const VERDICT_AGE_THRESHOLD_MS = 90_000;

export function VerdictCard({
  variant,
  personnelName,
  contractorName,
  siteName,
  selectedSiteName,
  reason,
  scannedAt,
  method,
  permits,
  permitTitle,
  onAcknowledge,
  queuedCount = 0,
  nextIsDenial = false,
  className,
}: VerdictCardProps) {
  const { t } = useTranslation();
  const { label } = useDocumentTypes();
  const culture = currentCulture();
  const Icon = REASON_ICON[variant];
  const wordKey =
    variant === 'allowed'
      ? 'security.verdict.allowed'
      : variant === 'denied'
        ? 'security.verdict.denied'
        : variant === 'notFound'
          ? 'security.verdict.notFound'
          : 'security.verdict.networkError';

  const knownReason = reason && KNOWN_REASON_SET.has(reason) ? reason : null;
  const showTime = (variant === 'allowed' || variant === 'denied') && Boolean(scannedAt);
  const showAcknowledge = onAcknowledge != null;

  // İzin satırları — §17'nin SABİT sıralaması (`lib/permitWindow.ts`), HER varyantta AYNI
  // fonksiyon: rank 0 aktif+hibe, 1 aktif hibesiz, 2 ileri tarihli, 3 süresi geçmiş. Sunucunun
  // grup-İÇİ sırası (`validityStart` azalan) 0/1/3'te BOZULMAZ; yalnız 2 kendi içinde artan
  // yeniden sıralanır (§17 madde 3). Hiçbir izin `entryPermitted=true` DEĞİLKEN VE hiçbiri
  // `active` DEĞİLKEN bu bölümleme YAPISAL olarak "aktif-hibesiz-önce" üretir — G1'in düzeltilmiş
  // notunun ateşlediği durumla ÖRTÜŞÜR, ayrı bir özel durum GEREKMEZ (§17 madde 5).
  const rankedPermits = permits ? rankPermits(permits) : [];
  // §19 madde 1 — pencere dışı kırılımı TÜM liste üzerinden (kaydırılan/görünmeyen parça DEĞİL,
  // her zaman doğru — ölçüm GEREKMEZ).
  const windowCounts = permits ? permitWindowCounts(permits) : { future: 0, expired: 0 };
  // G1 FIX (S32e §1.2, S32f'de DEĞİŞMEDİ — §21.1 madde 1) — ayrım DİZİNİN VARLIĞINDA,
  // İÇERİĞİNDE DEĞİL: kapı yolunda `permits` DAİMA bir dizidir (boş olabilir, `null` OLMAZ —
  // §29.5), TC yolunda `undefined`'dır ve orada §29.5 madde 3 HİÇ DEĞERLENDİRİLEMEZ (izin listesi
  // hiç dönmez). Anahtar BİLEREK `validityState`'e BAKMAZ: not "İzin bu okutmadan sonra DEĞİŞTİ"
  // der, kendiliğinden sona eren bir izin DEĞİŞMEMİŞTİR (§21.1 madde 1).
  const hasLiveMismatch =
    variant === 'allowed' && permits != null && !permits.some((p) => p.entryPermitted);

  // S32g — kapı uygunluk kontrol listesi (`lib/eligibility.ts`, tek doğruluk kaynağı, modal ile
  // PAYLAŞILIR). `findEvaluatedPermit` `permits` `undefined`/boş İSE ya da hiçbir kalemde
  // `closestToEntry === true` DEĞİLSE (backend S32g'yi henüz DAĞITMADIYSA HER ZAMAN bu durum)
  // `null` döner — kontrol listesi o zaman TAMAMEN atlanır (dosya başı "undefined false değildir"
  // kuralının BURADAKİ uygulaması, `contractorName` S32c'nin AYNI dersi).
  const evaluatedPermit = findEvaluatedPermit(permits);
  const eligibility = evaluatedPermit ? eligibilityRows(evaluatedPermit, label) : [];
  const hasEligibility = evaluatedPermit != null && eligibility.length > 0;
  // Tasarım otoritesi §4.2/§4.3 — temiz bir onayda (üç satır da geçer) kontrol listesi kartta HİÇ
  // render EDİLMEZ (onay sözcüğü zaten yeterli); yalnız BAŞARISIZ bir satır varken (satırın kendi
  // olgusu, `variant`'a BAKMAKSIZIN) render edilir. `denied`'de her zaman (evaluatedPermit VARSA).
  const hasFailedEligibilityRow = eligibility.some((row) => row.state === 'fail');
  const showEligibility =
    (variant === 'denied' && hasEligibility) || (variant === 'allowed' && hasFailedEligibilityRow);
  const eligibilityToRender: EligibilityRow[] | null = showEligibility ? eligibility : null;
  // Tasarım otoritesi §2.1 (J6) — 1/2. satırdan biri `Eksik` iken kartın TEK yönlendirme cümlesi
  // `security.reason.<kod>.action`'ın YERİNE geçer, ASLA yığılmaz; yalnız `denied`'de anlamlıdır
  // (S32d §6.1/F8 — modal bir KAYITTIR, canlı imperatif TAŞIMAZ).
  const eligibilityRouteTo = variant === 'denied' ? eligibilityRouting(eligibility) : null;

  // §18 — liste kartın kalan yüksekliğini DOLDURUR ve yalnız GERÇEK taşmada kaydırır.
  // `tabIndex={0}` YALNIZ taştığında (H7 — odaksız bir kaydırma kutusu Chrome'da klavyeyle
  // kaydırılamaz). Ölçüm mount-once DEĞİL — satır listesi (yeni okutma) VE pencere yeniden
  // boyutlanması değiştiğinde yeniden ölçülür.
  const permitListRef = useRef<HTMLUListElement>(null);
  const [permitListScrollable, setPermitListScrollable] = useState(false);
  // `permits`/`variant` yalnız YENİDEN ÖLÇÜM tetikleyicisi — `measure()` DOM'dan okur, bu ikisini
  // OKUMAZ. Bir okutma/varyant değişince liste İÇERİĞİ değişir, yalnız o zaman yeniden ölçülmesi
  // GEREKİR.
  // biome-ignore lint/correctness/useExhaustiveDependencies: yukarıdaki not.
  useEffect(() => {
    function measure() {
      const el = permitListRef.current;
      setPermitListScrollable(el != null && el.scrollHeight > el.clientHeight + 1);
    }
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [permits, variant]);
  const permitsEyebrowId = useId();

  // Erişilebilir duyuru — bu kart bir güvenlik kararı taşır, sayfada tek yerdir (`VerdictPanel`).
  // `<output>` (`role="status"`) + `aria-live="polite"` (`assertive` DEĞİL) — kart dakikada
  // onlarca kez kendini değiştirebilir, `polite` mevcut anonsu kesmeden KUYRUKLAR.
  const reasonAnnouncement =
    variant === 'denied'
      ? knownReason
        ? t(`security.reason.${knownReason}.label`)
        : t('security.reason.unknown.label')
      : null;
  const announcement = [t(wordKey), personnelName, reasonAnnouncement].filter(Boolean).join(' — ');

  // S32c Option A (§2.2), S32d'de de GEÇERLİ — kimlik döşemesi `variant`'a bağlı: `notFound`/
  // `networkError`'da HİÇ render edilmez (kişi YOK), `allowed`/`denied`'de HER ZAMAN render
  // edilir (boş ad bile boş bir tile'a düşer — "?" YOK).
  const showIdentity = variant === 'allowed' || variant === 'denied';

  // §19 — pinned satır, en çok İKİ parça: pencere-dışı kırılımı + kaydırma işareti. Hiçbiri
  // uygulanmazsa satır HİÇ render edilmez.
  const nonActiveFragments: string[] = [];
  if (windowCounts.future > 0) {
    nonActiveFragments.push(
      t('security.verdict.permits.count.future', { count: windowCounts.future }),
    );
  }
  if (windowCounts.expired > 0) {
    nonActiveFragments.push(
      t('security.verdict.permits.count.expired', { count: windowCounts.expired }),
    );
  }
  const nonActiveLine = nonActiveFragments.join(' · ');
  // S32g PART TWO §20 (K5 fix) — pinned satır artık YALNIZ liste GERÇEKTEN taşarken render
  // edilir; eskiden `nonActiveLine` TEK BAŞINA satırı tetikliyordu ve liste taşmadığında (her
  // satır zaten kendi çipini taşıyorken) aynı sayıyı İKİNCİ kez tekrarlıyordu. SAYIM kuralı
  // DEĞİŞMEDİ — `nonActiveLine` hâlâ TÜM liste üzerinden hesaplanır (S32e §19 madde 1), yalnız
  // GÖSTERİM koşulu daraldı.
  const showPinnedLine = permitListScrollable;
  const pinnedLine = showPinnedLine ? (
    <p className="flex shrink-0 items-center justify-between gap-2 text-xs text-muted">
      {nonActiveLine ? (
        <span className="min-w-0 truncate">{nonActiveLine}</span>
      ) : (
        <span aria-hidden="true" />
      )}
      <span className="inline-flex shrink-0 items-center gap-1">
        <ChevronDown className="h-3 w-3 shrink-0" aria-hidden="true" />
        {t('security.verdict.permits.scrollMore')}
      </span>
    </p>
  ) : null;

  // §18 — izin listesi: `allowed` YALNIZ (Option A, PART TWO §21 — `denied`'de ARTIK render
  // EDİLMİYOR, bkz. aşağıdaki `denied` dalı notu). Kaydırma bölgesi `min-h-0 flex-1
  // overflow-y-auto` (H6 — `min-h-0` OLMADAN liste küçülmeyi REDDEDER ve eylem çubuğunu karttan
  // İTER); `overscroll-contain` sonuna varınca sayfanın kendisinin kaymasını ENGELLER.
  //
  // S32g PART TWO §17 madde 1 (K1 fix) — kontrol listesinin eksik kalem ADLARI bu `<ul>`'A BİR
  // DAHA ASLA enjekte EDİLMEZ (eskiden BURADA, `İZİNLER` listesinin İÇİNDE render ediliyordu —
  // canlı defekt: bir eksik eğitim dördüncü bir İZİN gibi okunuyordu, `aria-labelledby` de bu
  // yüzden YANLIŞTI). Kalemler artık `EligibilityChecklist`'in KENDİ satırının hücresi İÇİNDE —
  // bu liste artık YALNIZ izinlerdir, `aria-labelledby={permitsEyebrowId}` bu yüzden DOĞRUdur.
  function renderPermitList() {
    return (
      <ul
        ref={permitListRef}
        aria-labelledby={permitsEyebrowId}
        tabIndex={permitListScrollable ? 0 : undefined}
        className="flex min-h-0 flex-1 flex-col gap-1 overflow-y-auto overscroll-contain rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1"
      >
        {rankedPermits.map((permit, index) => {
          const chip = permitChip(permit);
          const ChipIcon = chip.icon;
          return (
            <li
              key={`${permit.title}-${permit.validityStart}-${index}`}
              className="flex min-w-0 shrink-0 items-center gap-2 text-sm"
            >
              <span className="min-w-0 flex-1 truncate font-medium text-fg" title={permit.title}>
                {permit.title}
              </span>
              <span
                className={cn(
                  'inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-xs',
                  PERMIT_CHIP_TEXT_CLASS[chip.tone],
                )}
              >
                <ChipIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
                {t(chip.labelKey)}
              </span>
            </li>
          );
        })}
      </ul>
    );
  }

  return (
    <div className={cn('flex h-full flex-col', className)}>
      <output aria-live="polite" aria-atomic="true" className="sr-only block">
        {announcement}
      </output>

      {/* Kimlik + karar şeridi — S32d §3.1. TEK doygun eleman 4px sol kural; şeridin kendisi
          TENT (`*-subtle`/`bg-surface-muted`). `min-h-[11rem]` DÖRT varyantta da AYNI sınıf —
          kimliksiz varyantlarda `justify-center` karar satırını ORTALAR, şerit KÜÇÜLMEZ. */}
      <div
        className={`flex min-h-[11rem] flex-col justify-center gap-3 border-l-4 px-5 py-4 ${STRIP_TONE[variant]}`}
      >
        <div className="flex items-center gap-3">
          <Icon className={`h-7 w-7 shrink-0 ${WORD_TONE[variant]}`} aria-hidden="true" />
          <span className={`text-3xl font-bold uppercase tracking-wide ${WORD_TONE[variant]}`}>
            {t(wordKey)}
          </span>
          {showTime && scannedAt ? (
            <span className="ml-auto shrink-0 text-right text-sm tabular-nums text-muted">
              {t('security.verdict.decidedAt', { time: formatTime(scannedAt, culture) })}
              <VerdictAgeSuffix
                since={scannedAt}
                tone={variant === 'denied' ? 'danger' : 'muted'}
              />
            </span>
          ) : null}
        </div>

        {showIdentity ? (
          <div className="flex min-w-0 gap-3">
            <VerdictAvatar name={personnelName} />
            <div className="flex min-w-0 flex-col justify-center gap-1">
              <p className="line-clamp-2 break-words text-2xl font-bold leading-tight text-fg">
                {personnelName}
              </p>
              <div className="flex min-w-0 flex-wrap items-center gap-x-1.5 gap-y-1 text-xs text-muted">
                {contractorName ? (
                  <span className="inline-flex min-w-0 max-w-[16rem] items-center gap-1">
                    <HardHat className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
                    <span className="sr-only">{t('security.contractor.srLabel')}</span>
                    <span className="min-w-0 truncate" title={contractorName}>
                      {contractorName}
                    </span>
                  </span>
                ) : null}
                {contractorName && (siteName || method) ? <span aria-hidden="true">·</span> : null}
                {siteName ? (
                  <span className="inline-flex min-w-0 items-center gap-1">
                    <MapPin className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
                    <span className="sr-only">{t('security.site.srLabel')}</span>
                    <span className="min-w-0 truncate">{siteName}</span>
                  </span>
                ) : null}
                {siteName && method ? <span aria-hidden="true">·</span> : null}
                {method ? (
                  <MethodMarker method={method} selfAssertedSuffix={method === 'GateQr'} />
                ) : null}
              </div>
            </div>
          </div>
        ) : null}
      </div>

      {/* Kanıt şeridi — S32d §3.2/§3.3, S32e §4.3 madde 2 ile ESNEK, S32f §18 ile TAM yükseklik.
          `flex-1 min-h-[9rem]` — taban ÜÇ satıra çıktı (S32e'nin iki satırlık `7.5rem`'inden,
          §18 "floor" kuralı; `web-qa-engineer` gerçek pikseli DOĞRULAMALI). `[Karar | Giriş]`
          ızgarasında satırın yüksekliği `Giriş` tarafından belirlendiğinde (`GateStage`'in
          sabitlenmiş taban yüksekliği, G7) artan boşluk artık BURAYA sığan TÜM listeyi gösterir,
          taşan kısım kendi İÇİNDE kaydırır (`renderPermitList`, H6/H7). */}
      <div className="flex-1 min-h-[9rem] overflow-hidden border-t border-border px-5 py-3">
        {variant === 'allowed' ? (
          rankedPermits.length > 0 ? (
            <div className="flex h-full min-h-0 flex-col gap-3">
              {/* S32g, tasarım otoritesi §4.3 — "işaretlenmemiş bir kayıp": bir HİBE dondurulmuş
                  olsa da bir READİNESS satırı SONRADAN başarısız olabilir (ör. bir Sağlık Raporu
                  süresi dolmuş). Ton satırın KENDİ olgusundan gelir, `variant`'tan DEĞİL — bu
                  yüzden `EligibilityChecklist` burada de AYNI bileşen, AYNI tonlarla render edilir.
                  Yönlendirme cümlesi YOK (§4.3 — kişi zaten içeri alındı, yönlendirilecek kimse
                  yok). */}
              {eligibilityToRender && evaluatedPermit ? (
                <EligibilityChecklist
                  permit={evaluatedPermit}
                  rows={eligibilityToRender}
                  density="card"
                />
              ) : null}
              <div className="flex min-h-0 flex-1 flex-col gap-1.5">
                <div className="flex shrink-0 items-center justify-between gap-2">
                  <span id={permitsEyebrowId} className="text-[11px] font-semibold text-muted">
                    {t('security.verdict.permits.eyebrow', { count: rankedPermits.length })}
                  </span>
                  {hasLiveMismatch ? (
                    <Tag color="gray" className="shrink-0 gap-1">
                      <TriangleAlert className="h-3 w-3 shrink-0" aria-hidden="true" />
                      {t('security.verdict.liveMismatch')}
                    </Tag>
                  ) : null}
                </div>
                {renderPermitList()}
                {pinnedLine}
              </div>
            </div>
          ) : permitTitle ? (
            // §18.2 — TC yolu: tek başlık, eyebrow YOK (`permits` hiç dönmez, §29.5). Bir
            // NOTİCE'tir, ORTALANIR (liste DEĞİL, tek liste ASLA ortalanmaz).
            <div className="flex h-full items-center justify-center">
              <p className="truncate text-sm font-medium text-fg" title={permitTitle}>
                {permitTitle}
              </p>
            </div>
          ) : (
            // §18.2 — kapı yolu, `permits=[]` (ör. bir `Terminal` reddi burada asla görünmez,
            // bu yalnız `allowed`; nadir ama meşru). NOTİCE, ORTALANIR.
            <div className="flex h-full items-center justify-center">
              <p className="text-sm text-muted">{t('security.verdict.permits.empty')}</p>
            </div>
          )
        ) : null}

        {variant === 'denied' ? (
          <div className="flex h-full min-h-0 flex-col gap-3">
            {/* Ret bloğu — S32d §3.2, H3 fix: artık `h-full` DEĞİL (eskiden ızgaranın verdiği
                tüm yüksekliğe geriliyordu, ~585×350 gereksiz bir tint). Kendi `shrink-0` kutusu. */}
            <div className="flex shrink-0 flex-col gap-1.5 rounded-md bg-danger-subtle p-3">
              <span className="text-sm font-bold text-danger">
                {knownReason
                  ? t(`security.reason.${knownReason}.label`)
                  : t('security.reason.unknown.label')}
              </span>
              <span className="text-sm text-fg">
                {/* S32g, tasarım otoritesi §2.1 (J6) — 1/2. satırdan biri `Eksik` iken bu satır
                    `security.reason.<kod>.action`'ın YERİNE geçer, ASLA yığılmaz (kartta TEK
                    yönlendirme cümlesi). */}
                {eligibilityRouteTo
                  ? t(`security.eligibility.route.${eligibilityRouteTo}`)
                  : knownReason
                    ? t(`security.reason.${knownReason}.action`)
                    : t('security.reason.unknown.action')}
              </span>
              {knownReason === 'OutOfSite' && selectedSiteName ? (
                <span className="text-sm text-muted">
                  {t('security.verdict.selectedSite', { site: selectedSiteName })}
                </span>
              ) : null}
            </div>
            {/* S32g PART TWO §2 (fallback'e ALINDI, aynı dokümanın §21 Option B'si) — kontrol
                listesi §17-§19'un nesting/border düzeltmeleriyle KALIR (K1/K3 kapalı), Option A'nın
                "sıralı izin listesi denied'den TAMAMEN KALKAR" kararı GERİ ALINDI: owner'ın "büyük
                boş dikey alan" şikâyeti bu ekranda İKİ kez tekrarlandı, o da Option A'nın §7.4'te
                YAZILI GİDEREMEDİĞİ tam şey (headline ret: satır 1/2 geçti, satır 3 `Bekleniyor`,
                kalemsiz ⇒ ~150px hava). Liste + `İZİNLER (N)` eyebrow'u + kaydırma bölgesi +
                pinned satır aşağıda GERİ DÖNÜYOR. `evaluatedPermit` YOKSA (ör. `Terminal`/
                `NoPermit`, boş `permits[]`) kontrol listesi HİÇ render edilmez — ret bloğu tek
                başına kalır. */}
            {eligibilityToRender && evaluatedPermit ? (
              <EligibilityChecklist
                permit={evaluatedPermit}
                rows={eligibilityToRender}
                density="card"
              />
            ) : null}
            {/* Sıralı izin listesi — S32g PART TWO §2 (fallback'e ALINDI, `S32g-eligibility-
                checklist.md` §21 Option B). Owner'ın "büyük boş dikey alan" şikâyeti İKİ kez
                tekrarlandığından Option A'nın (listesiz denied) bıraktığı ~150px hava kabul
                EDİLEMEZ bulundu — liste GERİ DÖNDÜ. K1 burada TEKRAR AÇILMAZ: `renderPermitList`
                (yukarıda) hâlâ YALNIZ `rankedPermits`'i okur, eligibility kalemi hiç ALMAZ/
                enjekte ETMEZ — bir kalem bu `<ul>`'a bir daha ASLA giremez, `aria-labelledby`
                bu yüzden DOĞRU kalır. Ret bloğuyla HİÇBİR görsel bağ YOK (§20 — ne ortak tint ne
                bağlayıcı çizgi, `gap-3` bu ayrımı taşır); kontrol listesiyle de AYNI kural.
                Reason kodu boş bir `permits[]` üretebilir (§29.5, `Terminal`) ya da TC yolu
                (`permitTitle` var, `permits` YOK) — ikisinde de bölüm HİÇ render edilmez. */}
            {rankedPermits.length > 0 ? (
              <div className="flex min-h-0 flex-1 flex-col gap-1.5">
                <span
                  id={permitsEyebrowId}
                  className="shrink-0 text-[11px] font-semibold text-muted"
                >
                  {t('security.verdict.permits.eyebrow', { count: rankedPermits.length })}
                </span>
                {renderPermitList()}
                {pinnedLine}
              </div>
            ) : null}
          </div>
        ) : null}

        {variant === 'notFound' ? (
          <div className="flex h-full flex-col justify-center gap-1 rounded-md bg-surface-muted p-3">
            <span className="text-sm font-semibold text-fg">{t('security.tc.notFound.title')}</span>
            <span className="text-sm text-muted">{t('security.tc.notFound.action')}</span>
          </div>
        ) : null}

        {variant === 'networkError' ? (
          <div className="flex h-full flex-col justify-center gap-1 rounded-md bg-surface-muted p-3">
            <span className="text-sm font-semibold text-fg">
              {t('security.verdict.networkError.title')}
            </span>
            <span className="text-sm text-muted">{t('security.verdict.networkError.body')}</span>
          </div>
        ) : null}
      </div>

      {/* Eylem çubuğu — S32d §3.4. Kendi sabit satırı (`h-14`) — `max-w-[20rem]` ARTIK
          GEREKMEZ, konumu satırın kendisi tutar. Ağırlık DURUMA göre: boş kuyrukta `secondary`
          (kartı ATAN bir kontrol yüksek sesli OLMAMALI), dolu kuyrukta `primary` (kapıda
          bekleyen VARSA bu masanın birincil eylemidir). */}
      <div className="flex h-14 items-center justify-end border-t border-border px-5">
        {showAcknowledge ? (
          <Button
            size="lg"
            variant={queuedCount > 0 ? 'primary' : 'secondary'}
            className="min-w-[11rem] tabular-nums"
            onClick={onAcknowledge}
          >
            {queuedCount > 0 ? (
              <>
                {nextIsDenial ? <OctagonX className="h-4 w-4 shrink-0" aria-hidden="true" /> : null}
                <span aria-hidden="true">
                  {t('security.verdict.acknowledgeQueued', { count: queuedCount })}
                </span>
                <span className="sr-only">
                  {nextIsDenial ? `${t('security.verdict.acknowledgeQueuedDenialSr')} — ` : ''}
                  {t('security.verdict.acknowledgeQueuedSr', { count: queuedCount })}
                </span>
              </>
            ) : (
              t('security.verdict.acknowledge')
            )}
          </Button>
        ) : null}
      </div>
    </div>
  );
}

/**
 * Yaş soneki (§2.4 kural 7, `allowed`'ı da kapsayacak şekilde GENİŞLETİLDİ) — "stale-verdict
 * defence": bir karar auto-clear KALKTIĞINDAN artık SÜRESİZ sahnede kalabilir; bu sonek olmadan
 * bir guard dakikalar önceki bir "GİRİŞ VAR"a bakıp GÜNCELMİŞ gibi davranabilir. S32d ile ayrı
 * bir şerit (`VerdictAgeLine`) DEĞİL, zaman yuvasının İÇİNDE bir sonek — "ne zaman" sorusunun
 * TEK bir okuma yeri olsun diye (F5 defekti: kart beşinci bir yatay bölge KAZANMAMALI). `denied`
 * kendi kırmızı tonunu korur; `allowed` NÖTR kalır (turuncu/kırmızı YOK — izin verilmiş bir
 * kararın yaşlanması onu YANLIŞ yapmaz, yalnız ŞÜPHELİ kılar). 15 sn'de bir kendini yeniler
 * (canlı saat) — bir `setInterval`'ın TEK işi budur.
 */
function VerdictAgeSuffix({ since, tone }: { since: string; tone: 'danger' | 'muted' }) {
  const { t } = useTranslation();
  const [, bumpTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => bumpTick((n) => n + 1), 15_000);
    return () => clearInterval(id);
  }, []);

  const sinceMs = new Date(since).getTime();
  if (Number.isNaN(sinceMs)) {
    return null;
  }
  const elapsedMs = Date.now() - sinceMs;
  if (elapsedMs < VERDICT_AGE_THRESHOLD_MS) {
    return null;
  }
  const minutes = Math.max(1, Math.floor(elapsedMs / 60_000));
  const toneClass = tone === 'danger' ? 'text-danger' : 'text-muted';

  return (
    <span className={toneClass}>
      {' · '}
      {t('security.verdict.decidedAgo', { minutes })}
    </span>
  );
}
